import { throwError as observableThrowError, Observable } from 'rxjs'
import { tap, catchError } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http'

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const excludedUrl = ['../api/File/UploadFile']
        const requestUrl = req.url

        //derive ins co if possible
        var insCo = 'unknown'
        if (requestUrl.search('route=/ssi/') > 0) {
            insCo = 'ssi'
        } else if (requestUrl.search('route=/neje/') > 0) {
            insCo = 'neje'
        }

        if (!excludedUrl.some((x) => x === req.url)) {
            console.log('Excluded request: ' + req.url)
            const dupReq = req.clone({ headers: req.headers.set('Content-Type', 'application/json') })

            return next.handle(dupReq).pipe(
                tap((ev: HttpEvent<any>) => {
                    if (ev instanceof HttpResponse) {
                        console.log('Processing response ', ev)
                    }
                }),
                catchError((response) => {
                    if (response instanceof HttpErrorResponse) {
                        console.log('Processing http error ', response)
                        if (response.status === 401 || response.status === 403) {
                            sessionStorage.clear()
                            localStorage.clear()
                            if (insCo === 'ssi') {
                                window.location.href = '/Auth/Logout.aspx?insCo=ssi'
                            } else if (insCo === 'neje') {
                                window.location.href = '/Auth/Logout.aspx?insCo=neje'
                            } else {
                                //send without a context. see if we can redirect the user to a page with an error message and direct them to login page.
                                window.location.href = '/Auth/Logout.aspx'
                            }
                            // return
                        }
                        //if (response.status == 404) {
                        //    window.location.href = '/ep-ui/#/pagenotfound'
                        //    return;
                        //}
                    }
                    return observableThrowError(response)
                })
            )
        } else {
            return next.handle(req)
        }
    }
}
